export const returnPayload = <P>(_state: P, payload: P): P => payload;
export const spreadPayloadOverState = <S extends object, P extends object>(
  state: S,
  payload: P
) => ({ ...state, ...payload });
export const returnFalse = () => false;
export const returnTrue = () => true;
export const returnNull = () => null;
export const returnZero = () => 0;
